import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from 'components/common/modal';

import { closeModal } from 'features/modalSlice';

import './ReviewsModal.css';
import {
    applyImportantStyles,
    isMobileDeviceRequest,
    // makeStatsRequestThrottled,
    stripHTMLTags,
} from 'lib';
import { Dropdown } from 'components/common/dropdown';
import {
    getBookingWidgetReviews,
    resetReviews,
    setReviews,
    setSortByScoreOptions,
} from '../../features/ReviewsSlice';
import axios from 'axios';
import { apiConfig } from 'config';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';
import { NoResults } from 'components/common/noResults';
import {
    FaBed,
    FaBitbucket,
    FaBuilding,
    FaCloudSun,
    FaFilter,
    FaGlobeEurope,
    FaHandHoldingUsd,
    FaLocationArrow,
    FaMedal,
    FaMoon,
    FaTree,
    FaUsers,
    FaWifi,
} from 'react-icons/fa';
// import { openDrawer } from 'features/drawersSlice';
import { Collapsible } from 'components/common/collapsible';
import { ReadMore } from 'components/common/readMore';
// import { CLICK_ACTIONS } from '../../constants';
// import { useOpenOldWidget } from 'hooks';
import { Stars } from 'components/common/stars';
import {
    MdCallEnd,
    MdChatBubbleOutline,
    MdFilterList,
    MdMyLocation,
    MdRoomService,
} from 'react-icons/md';
import { BsCheck2All } from 'react-icons/bs';
import { BiCommentAdd } from 'react-icons/bi';
import { CSSTransition } from 'react-transition-group';
const ReviewsModal = () => {
    const dispatch = useDispatch();

    const colors = useSelector(
        (state) => state.miniBookingWidget?.data?.colors
    );
    const isMobileDevice = isMobileDeviceRequest();
    const reviewsUrl =
        useSelector((state) => state.miniBookingWidget?.data?.commentsUrl) ||
        '';
    const isOpen = useSelector((state) => state.modal.isReviewsModalOpen);
    const {
        reviews,
        channelScores,
        totalReviewsText,
        guestScore,
        guestScoreValueText,
        channelExtras,
        totalReviews,
    } = useSelector((state) => state.reviews) || {};

    const handleModalClose = useCallback(() => {
        dispatch(closeModal({ modalId: 'ReviewsModal' }));
    });
    const {
        country,
        noResultsFound,
        networkError,
        noReviews,
        from,
        channels,
        // bookNow,
        categories,
        guestReviews,
        filters,
        orderCommentsBy,
        reviewScore,
        seasons,
        more,
        less,
        averageRatingScore,
        totalNumberOfReviews,
        allSources,
    } = useSelector((state) => state.miniBookingWidget?.data?.Lang) || {};
    const userProvidedData = useSelector((state) => state.user);
    const propertyID = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyID
    );
    // const clickAction = useSelector(
    //     (state) => state.miniBookingWidget?.data?.Behavior
    // );
    // const ourPrice = useSelector(
    //     (state) => state.miniBookingWidget?.data?.ourPrice
    // );
    const [reviewsPage, setReviewsPage] = useState(1);
    const [sortReviewsBy, setSortReviewsBy] = useState('');
    const [selectedReviewsCountry, setSelectedReviewsCountry] = useState('');
    const [selectedReviewsScore, setSelectedReviewsScore] = useState('');
    const [selectedReviewsSeason, setSelectedReviewsSeason] = useState('');
    const [hasMore, setHasMore] = useState(true);
    const [fullReviewsRefresh, setFullReviewsRefresh] = useState(false);
    const [activeChannel, setActiveChannel] = useState('all');
    const [filterChannelID, setFilterChannelID] = useState(-1);
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const showCommentsByCountryOptions = useSelector(
        (state) => state.reviews?.showCommentsByCountryOptions
    );
    const sortByScoreOptions = useSelector(
        (state) => state.reviews?.sortByScoreOptions
    );
    const sortBySeasonOptions = useSelector(
        (state) => state.reviews?.sortBySeasonOptions
    );
    const sortByCommentsOptions = useSelector(
        (state) => state.reviews?.sortByCommentsOptions
    );
    const mobileClass = isMobileDevice ? 'reviews-modal-mobile' : '';
    const getMoreReviews = async (
        countryCode,
        sortBy,
        page,
        sortByScore,
        sortBySeason,
        filterByChannel
    ) => {
        try {
            const response = await axios.get(apiConfig.moreReviewsUrl, {
                params: {
                    PropertyID: propertyID,
                    lang: userProvidedData.language,
                    Country: countryCode || selectedReviewsCountry,
                    Sort: sortBy || sortReviewsBy,
                    Page: page || reviewsPage + 1,
                    SortScore: sortByScore || selectedReviewsScore,
                    SortSeason: sortBySeason || selectedReviewsSeason,
                    ChannelID: filterByChannel || filterChannelID,
                },
            });

            const reviews = response.data?.channelComments || [];

            dispatch(setReviews({ reviews: reviews || [] }));
            dispatch(
                setSortByScoreOptions({
                    sortByScoreOptions: response.data?.sortByScoreOptions || [],
                })
            );

            if (!page) {
                setReviewsPage(reviewsPage + 1);
            }

            if (reviews.length === 0) {
                setHasMore(false);
            }
        } catch (error) {
            toast.error(networkError, {
                autoClose: true,
                theme: 'colored',
            });
        }

        if (countryCode) {
            setSelectedReviewsCountry(countryCode);
        }

        if (sortBy) {
            setSortReviewsBy(sortBy);
        }

        if (sortByScore) {
            setSelectedReviewsScore(sortByScore);
        }

        if (sortBySeason) {
            setSelectedReviewsSeason(sortBySeason);
        }
        setFullReviewsRefresh(false);
    };
    const noReviewsAvailable = !reviews || reviews?.length === 0;
    useEffect(() => {
        if (reviewsUrl) {
            dispatch(getBookingWidgetReviews({ reviewsUrl }));
        }

        // TODO: DON'T KNOW IF THIS IS NECESSARY
        // return () => {
        //     cleanup;
        // };
    }, [reviewsUrl]);

    const handleChannelFilterClick = (channelID, channelName) => {
        if (activeChannel === channelName) return;
        setActiveChannel(channelName);
        setFilterChannelID(channelID);
        setFullReviewsRefresh(true);
        dispatch(resetReviews());
        getMoreReviews('', '', 1, '', '', channelID);
    };

    // const { clickHandler: openOldWidget } = useOpenOldWidget();
    // const handleBookNowClick = useCallback(() => {
    //     handleModalClose();
    //     if (
    //         CLICK_ACTIONS.OPEN_PLUGIN ||
    //         clickAction === CLICK_ACTIONS.OPEN_BIG_PLUGIN
    //     ) {
    //         if (clickAction === CLICK_ACTIONS.OPEN_BIG_PLUGIN) {
    //             dispatch(openDrawer({ drawerId: 'BigBookingWidgetDrawer' }));
    //             if (!document.body.classList.contains('ab-no-overflow')) {
    //                 document.body.classList.add('ab-no-overflow');
    //             }
    //         } else if (clickAction === CLICK_ACTIONS.LINK) {
    //             window.open(ourPrice?.url);
    //         } else {
    //             openOldWidget(clickAction);
    //         }
    //     } else {
    //         window.open(ourPrice?.url);
    //     }

    //     makeStatsRequestThrottled(
    //         WIDGET_STATS_SETTINGS.actions.click,
    //         propertyID
    //     );
    // });
    const renderContent = () => {
        return !isMobileDevice ? (
            <div className={`ab-contact-us-cnt ab-reviews-root`}>
                <div className="ab-reviews-fileters-reviews-wrapper">
                    <div className="ab-reviews-aside-root">
                        <section className="ab-reviews-layout-section-root ab-reviews-aside-categories-section">
                            <div className="ab-reviews-score-header-wrapper ab-reviews-score-header-wrapper-set-h">
                                <div className="ab-reviews-score-header-inner-upper">
                                    <Stars rating={1} size={50} />
                                    <div className="ab-reviews-total-score">
                                        {guestScore}
                                    </div>
                                </div>
                                <div className="ab-reviews-total ab-reviews-total-bubble">
                                    <div className="ab-reviews-total-score-text">
                                        {averageRatingScore}
                                    </div>
                                    <Stars rating={guestScore / 2} size={30} />
                                </div>
                            </div>
                            <div className="ab-reviews-score-header-wrapper ab-reviews-score-header-wrapper-extras">
                                <div className="ab-reviews-layout-section-title ">
                                    {categories}
                                </div>
                                <div className="ab-reviews-layout-section-content">
                                    <div className="ab-reviews-list-root ab-reviews-list-dividers ab-reviews-scores-by-category-root ">
                                        {channelExtras?.map(
                                            (channelExtra, index) => (
                                                <div
                                                    key={index}
                                                    className="ab-reviews-list-item-root ab-reviews-scores-by-category-list-item"
                                                >
                                                    <div className="ab-reviews-list-item-icon-root ab-reviews-scores-by-category-list-item-icon">
                                                        {channelExtra.categoryAlias ===
                                                        'Cleanliness' ? (
                                                            <FaBitbucket size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Comfort' ? (
                                                            <FaBed size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Facilities' ? (
                                                            <FaBuilding size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Property conditions & facilities' ? (
                                                            <FaBuilding size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Property conditions & facilities' ? (
                                                            <FaBuilding size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Free Wifi' ? (
                                                            <FaWifi size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'FreeWifi' ? (
                                                            <FaWifi size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Location' ? (
                                                            <FaLocationArrow size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Staff' ? (
                                                            <FaUsers size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Staff & service' ? (
                                                            <FaUsers size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'ValueForMoney' ? (
                                                            <FaHandHoldingUsd size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Value for money' ? (
                                                            <FaHandHoldingUsd size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Value' ? (
                                                            <FaHandHoldingUsd size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Eco-friendliness' ? (
                                                            <FaTree size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Rooms' ? (
                                                            <FaBed size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Check-in"' ? (
                                                            <FaBed size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Sleep Quality' ? (
                                                            <FaMoon size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Service' ? (
                                                            <MdRoomService size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Accuracy' ? (
                                                            <MdMyLocation size="14" />
                                                        ) : channelExtra.categoryAlias ===
                                                          'Communication' ? (
                                                            <MdCallEnd size="14" />
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                    <div className="ab-reviews-list-item-content ab-reviews-list-item-underlined  ab-reviews-scores-by-category-list-item-content">
                                                        <div>
                                                            {
                                                                channelExtra.categoryName
                                                            }
                                                        </div>
                                                        <b>
                                                            {
                                                                channelExtra.categoryScore
                                                            }
                                                        </b>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="ab-reviews-layout-section-root ab-reviews-aside-channels-section">
                            <div className="ab-reviews-score-header-wrapper ab-reviews-score-header-wrapper-set-h">
                                <div className="ab-reviews-score-header-inner-upper">
                                    <MdChatBubbleOutline size={31} />
                                    <div className="ab-reviews-total-score">
                                        {totalReviews}
                                    </div>
                                </div>
                                <div className="ab-reviews-total-score-count">
                                    {totalNumberOfReviews}
                                </div>
                            </div>
                            <div className="ab-reviews-score-header-wrapper ab-reviews-score-header-wrapper-extras">
                                <div className="ab-reviews-layout-section-title ">
                                    {channels}
                                </div>
                                <div className="ab-reviews-layout-section-content">
                                    <div className="ab-reviews-list-root ab-reviews-dividers ab-reviews-scores-by-channel-root">
                                        {channelScores.map((channel, index) => (
                                            <div
                                                key={index}
                                                className="ab-reviews-list-item-root"
                                            >
                                                <img
                                                    alt="tripadvisor icon"
                                                    className="ab-reviews-list-item-icon-root"
                                                    height="16"
                                                    src={channel.channelImage}
                                                    width="16"
                                                />
                                                <div className="ab-reviews-list-item-content ab-reviews-list-item-underlined">
                                                    <div>
                                                        {channel.channelName}
                                                    </div>
                                                    <div className="ab-reviews-scores-by-channel-score">
                                                        {channel.channelScore}
                                                        {
                                                            channel.channelScoreOutOf
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="ab-reviews-body-root ab-reviews-body">
                        <section className="ab-reviews-body-section-root ab-reviews-body-filters-section">
                            <div className="ab-reviews-filter-upper">
                                <div className="ab-reviews-filter-upper-wrapper">
                                    <div className="ab-reviews-filter-channels">
                                        <div
                                            className={`ab-reviews-channel-btn ${
                                                activeChannel === 'all'
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            onClick={() =>
                                                handleChannelFilterClick(
                                                    -1,
                                                    'all'
                                                )
                                            }
                                        >
                                            <BsCheck2All />
                                            {allSources}
                                        </div>
                                        {channelScores?.map(
                                            (channel, index) => (
                                                <div key={index}>
                                                    <div
                                                        className={`ab-reviews-channel-btn ab-reviews-channel-filter-extra ${
                                                            activeChannel ===
                                                            channel.channelName
                                                                ? 'active'
                                                                : ''
                                                        }`}
                                                        onClick={() =>
                                                            handleChannelFilterClick(
                                                                channel.channelID,
                                                                channel.channelName
                                                            )
                                                        }
                                                    >
                                                        <span className="ab-reviews-channel-filter-score-img">
                                                            <img
                                                                src={
                                                                    channel.channelImage
                                                                }
                                                                alt=""
                                                            />
                                                        </span>
                                                        <div className="ab-reviews-channel-filter-score">
                                                            <div className="ab-reviews-channel-filter-star">
                                                                <Stars
                                                                    rating={1}
                                                                />
                                                            </div>
                                                            {
                                                                channel.channelScore
                                                            }
                                                        </div>
                                                        <div className="ab-reviews-channel-filter-comment-count">
                                                            <div className="ab-reviews-channel-filter-comment-icon">
                                                                <BiCommentAdd />
                                                            </div>
                                                            {
                                                                channel.channelReviews
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                                <div
                                    className={`ab-reviews-filter-other ${
                                        isFiltersOpen && ' active'
                                    }`}
                                    onClick={() =>
                                        setIsFiltersOpen(!isFiltersOpen)
                                    }
                                >
                                    <div className="ab-reviews-filter-other-icon">
                                        <MdFilterList />
                                    </div>
                                    {filters}
                                </div>
                            </div>
                            <CSSTransition
                                in={isFiltersOpen}
                                timeout={300}
                                classNames="slide"
                                unmountOnExit
                            >
                                <div className="ab-reviews-filter-other-row">
                                    <div className="ab-reviews-body-section-content">
                                        <div className="ab-reviews-list-root ab-reviews-list-dividers">
                                            <div className="ab-reviews-list-item-root ab-reviews-list-item-filters">
                                                <div className="ab-reviews-filter">
                                                    <div className="ab-filters-name">
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            <FaGlobeEurope size="14" />
                                                        </span>
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            {country}
                                                        </span>
                                                    </div>
                                                    <Dropdown
                                                        align="left-unset"
                                                        fontSize="14px"
                                                        maxHeight="200px"
                                                        noResultsText={
                                                            noResultsFound
                                                        }
                                                        noSemicolon
                                                        onChange={(option) => {
                                                            const countryCode =
                                                                option.dropdownValue;
                                                            setFullReviewsRefresh(
                                                                true
                                                            );
                                                            dispatch(
                                                                resetReviews()
                                                            );
                                                            getMoreReviews(
                                                                countryCode,
                                                                '',
                                                                1,
                                                                '',
                                                                ''
                                                            );
                                                        }}
                                                        options={
                                                            showCommentsByCountryOptions
                                                        }
                                                        searchable
                                                        value={
                                                            selectedReviewsCountry
                                                        }
                                                        variant="outlined"
                                                        width="140px"
                                                    />
                                                </div>
                                                <div className="ab-reviews-filter">
                                                    <div className="ab-filters-name">
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            <FaFilter size="14" />
                                                        </span>
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            {orderCommentsBy}
                                                        </span>
                                                    </div>
                                                    <Dropdown
                                                        align="left-unset"
                                                        fontSize="14px"
                                                        label=""
                                                        maxHeight="200px"
                                                        noResultsText={
                                                            noResultsFound
                                                        }
                                                        noSemicolon
                                                        onChange={(option) => {
                                                            const sortBy =
                                                                option.dropdownValue;
                                                            setFullReviewsRefresh(
                                                                true
                                                            );
                                                            dispatch(
                                                                resetReviews()
                                                            );
                                                            getMoreReviews(
                                                                '',
                                                                sortBy,
                                                                1,
                                                                '',
                                                                ''
                                                            );
                                                        }}
                                                        options={
                                                            sortByCommentsOptions
                                                        }
                                                        searchable
                                                        value={sortReviewsBy}
                                                        variant="outlined"
                                                        width="140px"
                                                    />
                                                </div>
                                                <div className="ab-reviews-filter">
                                                    <div className="ab-filters-name">
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            <FaMedal size="14" />
                                                        </span>
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            {reviewScore}
                                                        </span>
                                                    </div>
                                                    <Dropdown
                                                        align="left-unset"
                                                        fontSize="14px"
                                                        label=""
                                                        maxHeight="200px"
                                                        noResultsText={
                                                            noResultsFound
                                                        }
                                                        noSemicolon
                                                        onChange={(option) => {
                                                            const sortByScore =
                                                                option.dropdownValue;
                                                            setFullReviewsRefresh(
                                                                true
                                                            );
                                                            dispatch(
                                                                resetReviews()
                                                            );
                                                            getMoreReviews(
                                                                '',
                                                                '',
                                                                1,
                                                                sortByScore,
                                                                ''
                                                            );
                                                        }}
                                                        options={
                                                            sortByScoreOptions
                                                        }
                                                        searchable
                                                        value={
                                                            selectedReviewsScore
                                                        }
                                                        variant="outlined"
                                                        width="140px"
                                                    />
                                                </div>
                                                <div className="ab-reviews-filter">
                                                    <div className="ab-filters-name">
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            <FaCloudSun size="14" />
                                                        </span>
                                                        <span
                                                            style={{
                                                                marginRight:
                                                                    '5px',
                                                            }}
                                                        >
                                                            {seasons}
                                                        </span>
                                                    </div>
                                                    <Dropdown
                                                        align="left-unset"
                                                        fontSize="14px"
                                                        label=""
                                                        maxHeight="200px"
                                                        noResultsText={
                                                            noResultsFound
                                                        }
                                                        noSemicolon
                                                        onChange={(option) => {
                                                            const sortBySeason =
                                                                option.dropdownValue;
                                                            setFullReviewsRefresh(
                                                                true
                                                            );
                                                            dispatch(
                                                                resetReviews()
                                                            );
                                                            getMoreReviews(
                                                                '',
                                                                '',
                                                                1,
                                                                '',
                                                                sortBySeason
                                                            );
                                                        }}
                                                        options={
                                                            sortBySeasonOptions
                                                        }
                                                        searchable
                                                        value={
                                                            selectedReviewsSeason
                                                        }
                                                        variant="outlined"
                                                        width="140px"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CSSTransition>
                        </section>
                        <section className="ab-reviews-section-root ab-reviews-body-review-list-section">
                            <div className="ab-reviews-section-title">
                                {guestReviews}
                            </div>
                            <div className="ab-reviews-section-content ab-reviews-body-review-list-section-content">
                                <div
                                    className="ab-reviews-scrollbar-master-container ab-reviews-scrollbar-column"
                                    style={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        width: '100%',
                                        height: 'auto',
                                        minHeight: '0px',
                                        maxHeight: '100%',
                                    }}
                                >
                                    <div
                                        className="ab-reviews-scrollbar-view"
                                        id="ab-reviews-comments-wrapper"
                                        style={{
                                            position: 'relative',
                                            overflow: ' hidden scroll',
                                            marginBottom: '0px',
                                            minHeight: ' 17px',
                                            maxHeight: '245px',
                                        }}
                                    >
                                        <div className="ab-reviews-card-list-root ab-reviews-body-review-list">
                                            {fullReviewsRefresh ? (
                                                <BarsLoadingIndicator
                                                    variant="puff"
                                                    size={75}
                                                    classes="ab-bars-loading-indicator--light-gray"
                                                />
                                            ) : noReviewsAvailable ? (
                                                <NoResults
                                                    message={noReviews}
                                                />
                                            ) : (
                                                <InfiniteScroll
                                                    dataLength={
                                                        reviews?.length || 0
                                                    }
                                                    hasMore={hasMore}
                                                    loader={
                                                        <BarsLoadingIndicator
                                                            size={25}
                                                            classes="ab-bars-loading-indicator--light-gray"
                                                            style={{
                                                                textAlign:
                                                                    'center',
                                                            }}
                                                        />
                                                    }
                                                    next={getMoreReviews}
                                                    scrollableTarget="ab-reviews-comments-wrapper"
                                                >
                                                    <div className="ab-reviews-card-list-list">
                                                        {reviews?.map(
                                                            (
                                                                channelComment,
                                                                index
                                                            ) => (
                                                                <div
                                                                    key={index}
                                                                    className="ab-reviews-card-padding-box ab-reviews-card-variant-outlined"
                                                                >
                                                                    <div className="ab-reviews-card-root">
                                                                        <div className="ab-reviews-card-inner-channel ab-reviews-card-inner">
                                                                            <img
                                                                                src={
                                                                                    channelComment.commentChannelIcon
                                                                                }
                                                                            />
                                                                            <span className="ab-reviews-card-inner-channel-name">
                                                                                {
                                                                                    channelComment.channelName
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div className="ab-reviews-card-inner-score ab-reviews-card-inner">
                                                                            {
                                                                                channelComment.channelScoreDecimal
                                                                            }
                                                                            <span className="ab-reviews-card-inner-score-star">
                                                                                <Stars
                                                                                    rating={
                                                                                        1
                                                                                    }
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                        <div className="ab-reviews-card-inner-date ab-reviews-card-inner">
                                                                            {
                                                                                channelComment.commentDate
                                                                            }
                                                                        </div>
                                                                        <div className="ab-reviews-card-inner-comment-wrapper ab-reviews-card-inner">
                                                                            <div className="ab-reviews-card-inner-comment">
                                                                                <b>
                                                                                    {
                                                                                        channelComment.commentTitle
                                                                                    }
                                                                                </b>
                                                                                <div>
                                                                                    <ReadMore
                                                                                        moreText={
                                                                                            more
                                                                                        }
                                                                                        lessText={
                                                                                            less
                                                                                        }
                                                                                    >
                                                                                        {stripHTMLTags(
                                                                                            channelComment.commentText
                                                                                        )}
                                                                                    </ReadMore>
                                                                                </div>
                                                                            </div>
                                                                            <div className="ab-reviews-card-inner-name">
                                                                                {
                                                                                    channelComment.commentName
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </InfiniteScroll>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                {/* <div className="ab-reviews-layout-aside-footer-root ab-reviews-aside-footer">
                    <a
                        href={'https://www.ratestrip.com/'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{}}
                    >
                        <img
                            src={
                                'https://static.abouthotelier.com/img/ratestrip_logo.svg'
                            }
                            alt=""
                            style={{
                                width: '80px',
                            }}
                            ref={(el) => {
                                applyImportantStyles(el, {
                                    display: 'unset',
                                    float: 'unset',
                                });
                            }}
                        />
                    </a>
                </div> */}
            </div>
        ) : (
            <div className={`ab-contact-us-cnt ab-reviews-root ${mobileClass}`}>
                <div className="ab-reviews-header">
                    <div className="ab-reviews-header-inner">
                        <div className="ab-reviews-total ab-reviews-total-bubble">
                            <div>
                                <div className="ab-reviews-total-score">
                                    {guestScore}
                                </div>
                            </div>
                            <div>
                                <div className="ab-reviews-total-score-text">
                                    {guestScoreValueText}
                                </div>
                                <div className="ab-reviews-total-score-count">
                                    {from} {totalReviewsText}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ab-reviews-main-data-wrapper">
                    {' '}
                    <div className="ab-reviews-aside-scroll-padding">
                        <div
                            className="ab-reviews-scrollbar-master-container ab-reviews-scrollbar-column"
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: 'auto',
                                minHeight: '0px',
                                maxHeight: '100%',
                            }}
                        >
                            <div
                                className="ab-reviews-scrollbar-view"
                                style={{
                                    position: 'relative',
                                    marginRight: '-17px',
                                    marginBottom: '0px',
                                    minHeight: '17px',
                                }}
                            >
                                <div
                                    className="ab-reviews-aside-body-root ab-reviews-aside-body"
                                    style={{ overflow: 'visible' }}
                                >
                                    <Collapsible title={channels} open>
                                        <div className="ab-reviews-layout-section-content">
                                            <div className="ab-reviews-list-root ab-reviews-dividers ab-reviews-scores-by-channel-root">
                                                {channelScores.map(
                                                    (channel, index) => (
                                                        <div
                                                            key={index}
                                                            className="ab-reviews-list-item-root"
                                                        >
                                                            <img
                                                                alt="tripadvisor icon"
                                                                className="ab-reviews-list-item-icon-root"
                                                                height="16"
                                                                src={
                                                                    channel.channelImage
                                                                }
                                                                width="16"
                                                            />
                                                            <div className="ab-reviews-list-item-content ab-reviews-list-item-underlined">
                                                                <div>
                                                                    {
                                                                        channel.channelName
                                                                    }
                                                                </div>
                                                                <div className="ab-reviews-scores-by-channel-score">
                                                                    {
                                                                        channel.channelScore
                                                                    }
                                                                    {
                                                                        channel.channelScoreOutOf
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </Collapsible>
                                    <Collapsible
                                        title={categories}
                                        open={false}
                                    >
                                        <div className="ab-reviews-layout-section-content">
                                            <div className="ab-reviews-list-root ab-reviews-list-dividers ab-reviews-scores-by-category-root ">
                                                {channelExtras?.map(
                                                    (channelExtra, index) => (
                                                        <div
                                                            key={index}
                                                            className="ab-reviews-list-item-root ab-reviews-scores-by-category-list-item"
                                                        >
                                                            <div className="ab-reviews-list-item-icon-root ab-reviews-scores-by-category-list-item-icon">
                                                                {channelExtra.categoryAlias ===
                                                                'Cleanliness' ? (
                                                                    <FaBitbucket size="14" />
                                                                ) : channelExtra.categoryAlias ===
                                                                  'Comfort' ? (
                                                                    <FaBed size="14" />
                                                                ) : channelExtra.categoryAlias ===
                                                                  'Facilities' ? (
                                                                    <FaBuilding size="14" />
                                                                ) : channelExtra.categoryAlias ===
                                                                  'FreeWifi' ? (
                                                                    <FaWifi size="14" />
                                                                ) : channelExtra.categoryAlias ===
                                                                  'Location' ? (
                                                                    <FaLocationArrow size="14" />
                                                                ) : channelExtra.categoryAlias ===
                                                                  'Staff' ? (
                                                                    <FaUsers size="14" />
                                                                ) : channelExtra.categoryAlias ===
                                                                  'ValueForMoney' ? (
                                                                    <FaHandHoldingUsd size="14" />
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                            <div className="ab-reviews-list-item-content ab-reviews-list-item-underlined  ab-reviews-scores-by-category-list-item-content">
                                                                <div>
                                                                    {
                                                                        channelExtra.categoryName
                                                                    }
                                                                </div>
                                                                <b>
                                                                    {
                                                                        channelExtra.categoryScore
                                                                    }
                                                                </b>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </Collapsible>
                                    <Collapsible
                                        title={filters}
                                        open={false}
                                        extraClass="ab-overf-v"
                                    >
                                        <div className="ab-reviews-body-section-content">
                                            <div className="ab-reviews-list-root ab-reviews-list-dividers">
                                                <div className="ab-reviews-list-item-root ab-reviews-list-item-filters">
                                                    <div className="ab-reviews-filter">
                                                        <div className="ab-filters-name">
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                <FaGlobeEurope size="14" />
                                                            </span>
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                {country}
                                                            </span>
                                                        </div>
                                                        <Dropdown
                                                            align="left-unset"
                                                            fontSize="14px"
                                                            maxHeight="200px"
                                                            noResultsText={
                                                                noResultsFound
                                                            }
                                                            noSemicolon
                                                            onChange={(
                                                                option
                                                            ) => {
                                                                const countryCode =
                                                                    option.dropdownValue;
                                                                setFullReviewsRefresh(
                                                                    true
                                                                );
                                                                dispatch(
                                                                    resetReviews()
                                                                );
                                                                getMoreReviews(
                                                                    countryCode,
                                                                    '',
                                                                    1,
                                                                    '',
                                                                    ''
                                                                );
                                                            }}
                                                            options={
                                                                showCommentsByCountryOptions
                                                            }
                                                            searchable
                                                            value={
                                                                selectedReviewsCountry
                                                            }
                                                            variant="outlined"
                                                            width="140px"
                                                        />
                                                    </div>
                                                    <div className="ab-reviews-filter">
                                                        <div className="ab-filters-name">
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                <FaFilter size="14" />
                                                            </span>
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                {
                                                                    orderCommentsBy
                                                                }
                                                            </span>
                                                        </div>
                                                        <Dropdown
                                                            align="left-unset"
                                                            fontSize="14px"
                                                            label=""
                                                            maxHeight="200px"
                                                            noResultsText={
                                                                noResultsFound
                                                            }
                                                            noSemicolon
                                                            onChange={(
                                                                option
                                                            ) => {
                                                                const sortBy =
                                                                    option.dropdownValue;
                                                                setFullReviewsRefresh(
                                                                    true
                                                                );
                                                                dispatch(
                                                                    resetReviews()
                                                                );
                                                                getMoreReviews(
                                                                    '',
                                                                    sortBy,
                                                                    1,
                                                                    '',
                                                                    ''
                                                                );
                                                            }}
                                                            options={
                                                                sortByCommentsOptions
                                                            }
                                                            searchable
                                                            value={
                                                                sortReviewsBy
                                                            }
                                                            variant="outlined"
                                                            width="140px"
                                                        />
                                                    </div>
                                                    <div className="ab-reviews-filter">
                                                        <div className="ab-filters-name">
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                <FaMedal size="14" />
                                                            </span>
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                {reviewScore}
                                                            </span>
                                                        </div>
                                                        <Dropdown
                                                            align="left-unset"
                                                            fontSize="14px"
                                                            label=""
                                                            maxHeight="200px"
                                                            noResultsText={
                                                                noResultsFound
                                                            }
                                                            noSemicolon
                                                            onChange={(
                                                                option
                                                            ) => {
                                                                const sortByScore =
                                                                    option.dropdownValue;
                                                                setFullReviewsRefresh(
                                                                    true
                                                                );
                                                                dispatch(
                                                                    resetReviews()
                                                                );
                                                                getMoreReviews(
                                                                    '',
                                                                    '',
                                                                    1,
                                                                    sortByScore,
                                                                    ''
                                                                );
                                                            }}
                                                            options={
                                                                sortByScoreOptions
                                                            }
                                                            searchable
                                                            value={
                                                                selectedReviewsScore
                                                            }
                                                            variant="outlined"
                                                            width="140px"
                                                        />
                                                    </div>
                                                    <div className="ab-reviews-filter">
                                                        <div className="ab-filters-name">
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                <FaCloudSun size="14" />
                                                            </span>
                                                            <span
                                                                style={{
                                                                    marginRight:
                                                                        '5px',
                                                                }}
                                                            >
                                                                {seasons}
                                                            </span>
                                                        </div>
                                                        <Dropdown
                                                            align="left-unset"
                                                            fontSize="14px"
                                                            label=""
                                                            maxHeight="200px"
                                                            noResultsText={
                                                                noResultsFound
                                                            }
                                                            noSemicolon
                                                            onChange={(
                                                                option
                                                            ) => {
                                                                const sortBySeason =
                                                                    option.dropdownValue;
                                                                setFullReviewsRefresh(
                                                                    true
                                                                );
                                                                dispatch(
                                                                    resetReviews()
                                                                );
                                                                getMoreReviews(
                                                                    '',
                                                                    '',
                                                                    1,
                                                                    '',
                                                                    sortBySeason
                                                                );
                                                            }}
                                                            options={
                                                                sortBySeasonOptions
                                                            }
                                                            searchable
                                                            value={
                                                                selectedReviewsSeason
                                                            }
                                                            variant="outlined"
                                                            width="140px"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Collapsible>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ab-reviews-body-root ab-reviews-body">
                        <section className="ab-reviews-section-root ab-reviews-body-review-list-section">
                            <div className="ab-reviews-section-title">
                                {guestReviews}
                            </div>
                            <div className="ab-reviews-section-content ab-reviews-body-review-list-section-content">
                                <div
                                    className="ab-reviews-scrollbar-master-container ab-reviews-scrollbar-column"
                                    style={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        width: '100%',
                                        height: 'auto',
                                        minHeight: '0px',
                                        maxHeight: '100%',
                                    }}
                                >
                                    <div
                                        className="ab-reviews-scrollbar-view"
                                        id="ab-reviews-comments-wrapper"
                                        style={{
                                            position: 'relative',
                                            overflow: ' hidden scroll',
                                            marginBottom: '0px',
                                            minHeight: ' 17px',
                                            maxHeight: '300px',
                                        }}
                                    >
                                        <div className="ab-reviews-card-list-root ab-reviews-body-review-list">
                                            {fullReviewsRefresh ? (
                                                <BarsLoadingIndicator
                                                    variant="puff"
                                                    size={75}
                                                    classes="ab-bars-loading-indicator--light-gray"
                                                />
                                            ) : noReviewsAvailable ? (
                                                <NoResults
                                                    message={noReviews}
                                                />
                                            ) : (
                                                <InfiniteScroll
                                                    dataLength={
                                                        reviews?.length || 0
                                                    }
                                                    hasMore={hasMore}
                                                    loader={
                                                        <BarsLoadingIndicator
                                                            size={25}
                                                            classes="ab-bars-loading-indicator--light-gray"
                                                            style={{
                                                                textAlign:
                                                                    'center',
                                                            }}
                                                        />
                                                    }
                                                    next={getMoreReviews}
                                                    scrollableTarget="ab-reviews-comments-wrapper"
                                                >
                                                    <div className="ab-reviews-card-list-list">
                                                        {reviews?.map(
                                                            (
                                                                channelComment,
                                                                index
                                                            ) => (
                                                                <div
                                                                    key={index}
                                                                    className="ab-reviews-card-padding-box ab-reviews-card-variant-outlined"
                                                                >
                                                                    <div className="ab-reviews-card-root">
                                                                        <div className="ab-reviews-card-header">
                                                                            <strong className="ab-reviews-card-name">
                                                                                {
                                                                                    channelComment.commentName
                                                                                }
                                                                            </strong>
                                                                            <span className="ab-reviews-card-score">
                                                                                <img
                                                                                    src={
                                                                                        channelComment.commentChannelIcon
                                                                                    }
                                                                                />
                                                                                <span>
                                                                                    {
                                                                                        channelComment.channelScore
                                                                                    }
                                                                                </span>
                                                                            </span>
                                                                        </div>
                                                                        <span className="ab-reviews-card-date">
                                                                            {
                                                                                channelComment.commentDate
                                                                            }
                                                                        </span>
                                                                        <div className="ab-reviews-card-body">
                                                                            <b>
                                                                                {
                                                                                    channelComment.commentTitle
                                                                                }
                                                                            </b>
                                                                            <div>
                                                                                <ReadMore
                                                                                    moreText={
                                                                                        more
                                                                                    }
                                                                                    lessText={
                                                                                        less
                                                                                    }
                                                                                >
                                                                                    {stripHTMLTags(
                                                                                        channelComment.commentText
                                                                                    )}
                                                                                </ReadMore>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </InfiniteScroll>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div className="ab-reviews-aside-root">
                    {/* <a
                        className="ab-reviews-button-root ab-reviews-button-size-small ab-reviews-button-edges-rounded ab-reviews-button-color-host ab-reviews-button-variant-filled ab-reviews-book-now-button-root"
                        style={{ width: '200px' }}
                        onClick={handleBookNowClick}
                    >
                        {bookNow}
                    </a> */}
                    <div className="ab-reviews-layout-aside-footer-root ab-reviews-aside-footer">
                        <a
                            href={'https://www.ratestrip.com/'}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{}}
                        >
                            <img
                                src={
                                    'https://static.abouthotelier.com/img/ratestrip_logo.svg'
                                }
                                alt=""
                                style={{
                                    width: '80px',
                                }}
                                ref={(el) => {
                                    applyImportantStyles(el, {
                                        display: 'unset',
                                        float: 'unset',
                                    });
                                }}
                            />
                        </a>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Modal
                className={
                    isMobileDevice
                        ? 'ab-modal--offer-mobile'
                        : 'ab-modal--offer'
                }
                color={colors?.primaryTextColor}
                backgroundColor={colors?.primaryBackgroundColor}
                isOpen={isOpen}
                onClose={handleModalClose}
                onOverlayClick={handleModalClose}
                placement={isMobileDevice ? 'top' : 'center'}
                renderContent={renderContent}
                styles={{
                    closeIcon: { color: 'black' },
                }}
                title=""
                variant="white-header"
                width={isMobileDevice ? '' : 1180}
            />
        </>
    );
};

export default ReviewsModal;
